import { $http } from './http'

const BASE_URL = '/user/company/pin'

class UserPinService {
  getUserPin = async (userId: number) => {
    const response = await $http.get(BASE_URL + '/' + userId)
    return response.data
  }
  updateUserPin = async (request: PinRequestDTO) => {
    const response = await $http.post(BASE_URL, request)
    return response.data
  }
}
export default new UserPinService()
